export type ReferralState = 'initial' | 'loaded' | 'processing';

export const REFERRAL_STATES: { [key in ReferralState]: ReferralState } = {
  initial: 'initial',
  loaded: 'loaded',
  processing: 'processing',
};
